import { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import { setAccount } from '../../../../reducer/action/account'
import { setToken } from '../../../../reducer/action/token'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { resolveToken } from '../../../../interface/auth'

const Secure = ({ children, authRequired = true }) => {
  const account = useSelector((state) => state.account)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const [isEvaluated, setIsEvaluated] = useState(false)

  useEffect(() => {
    const cookies = new Cookies()
    const token = cookies.get('token', { path: '/' })

    const evaluate = async () => {
      let account = false
      if (token) {
        account = await resolveToken(token)
      }
      if (account) {
        dispatch(setAccount(account))
        dispatch(setToken(token))
        setIsEvaluated(true)
      } else if (authRequired) {
        cookies.remove('token', { path: '/' })
        dispatch(setAccount(null))
        navigate('/')
      } else {
        setIsEvaluated(true)
      }
    }

    if (!isEvaluated) {
      evaluate()
    }
  }, [isEvaluated, authRequired, dispatch, navigate, account, pathname, searchParams])

  return isEvaluated ? <>{children}</> : <></>
}

export default Secure
